import { render, staticRenderFns } from "./ReturInsight.vue?vue&type=template&id=671439a2&scoped=true&"
import script from "./ReturInsight.vue?vue&type=script&lang=js&"
export * from "./ReturInsight.vue?vue&type=script&lang=js&"
import style0 from "./ReturInsight.vue?vue&type=style&index=0&id=671439a2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "671439a2",
  null
  
)

export default component.exports